export { parseYarnLockRawV2, stringifyYarnLockRawV2 } from './lib/v2';
export { parseYarnLockRawV1, stringifyYarnLockRawV1 } from './lib/v1';
